import { useState } from 'react';

import { Language } from '@breathelife/types';
import { FieldBlueprint, FieldTypes, ButtonFieldBlueprint } from '@zinnia/form-engine-sdk';

import {
  FieldDataFromBlueprint,
  FieldDataHookReturnValue,
  LanguageDependentSetter,
  useCastBlueprintToFieldType,
} from '../../Helpers/helperTypes';

export type ButtonFieldData = FieldDataFromBlueprint<ButtonFieldBlueprint, 'buttonText'>;

export type ButtonFieldSetters = {
  setButtonText: LanguageDependentSetter;
};

export function useButtonFieldData({
  initialData,
}: {
  initialData?: Partial<FieldBlueprint>;
}): FieldDataHookReturnValue<ButtonFieldData, ButtonFieldSetters> {
  const initialDataAsButtonField = useCastBlueprintToFieldType<ButtonFieldBlueprint>(FieldTypes.button, initialData);

  const [buttonTextEn, setButtonTextEn] = useState<Required<ButtonFieldData['buttonText']>['en']>(
    initialDataAsButtonField?.buttonText?.en || '',
  );

  const [buttonTextFr, setButtonTextFr] = useState<Required<ButtonFieldData['buttonText']>['fr']>(
    initialDataAsButtonField?.buttonText?.fr || '',
  );

  const setButtonText: LanguageDependentSetter = (language, value) => {
    switch (language) {
      case Language.en:
        setButtonTextEn(value);
        break;
      case Language.fr:
        setButtonTextFr(value);
        break;
    }
  };

  return {
    data: {
      buttonText: {
        en: buttonTextEn,
        fr: buttonTextFr,
      },
    },
    setters: {
      setButtonText,
    },
    clearData: () => {},
  };
}
